<template>
  <v-container class="pt-0">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg :site="site" :text="title" />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-slide-group class="py-0" center-active mandatory show-arrows>
          <!-- Slot ปุ่มกดฝั่งซ้าย (Prev) -->
          <template v-slot:prev="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>

          <!-- Slot ปุ่มกดฝั่งขวา (Next) -->
          <template v-slot:next="{ on, attrs }">
            <v-btn
              icon
              fab
              x-small
              v-bind="attrs"
              v-on="on"
              class="custom-slide-btn"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>

          <v-slide-item
            v-for="cate in categoryList"
            :key="cate.id"
            v-slot="{ active, toggle }"
            @change="initialize(cate)"
          >
            <v-card
              rounded="lg"
              class="px-4 mx-1"
              @click="toggle"
              elevation="0"
              width="15%"
              :style="
                active
                  ? { border: '1.5px solid', 'border-color': site.color }
                  : ''
              "
            >
              <v-container class="pa-0">
                <v-col class="d-flex justify-center pt-2 pb-0">
                  <v-icon :color="site.color">{{ `mdi-${cate.icon}` }}</v-icon>
                </v-col>
                <p style="font-size: 12px" class="text-center mb-0">
                  {{ cate.label }}
                </p>
              </v-container>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-container fluid>
      <v-row v-if="false" style="text-align: end; display: flow">
        <v-col cols="auto" class="px-0">
          <v-btn-toggle
            v-model="toggle_view"
            mandatory
            :color="site.color"
            style="border-radius: 20px; width: fit-content"
          >
            <v-btn small>
              <v-icon :color="toggle_view == 0 ? site.color : ''" small
                >mdi-view-headline</v-icon
              >
            </v-btn>
            <v-btn small>
              <v-icon :color="toggle_view == 1 ? site.color : ''" small
                >mdi-view-grid-outline</v-icon
              >
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row class="mt-2" v-if="toggle_view == 0">
        <v-col
          class="px-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
          v-for="(item, index) in list"
          :key="index"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              outlined
              elevation="1"
              width="100%"
              style="border: none"
              @click="openDetail(item)"
              :disabled="item.status == 2 || checkExpiredDate(item.expires_at)"
            >
              <div
                v-if="item.status == 2"
                class="d-flex justify-center align-center cover-card-disable"
              >
                <div class="label">{{ $t("isUsed") }}</div>
              </div>
              <div
                v-else-if="checkExpiredDate(item.expires_at)"
                class="d-flex justify-center align-center cover-card-disable"
              >
                <div class="label">{{ $t("myLuckyDrawExpire") }}</div>
              </div>

              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :lazy-src="require('@/assets/images/image.png')"
                :src="item.image_url"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                v-snip="{ lines: 3 }"
              >
                {{ item.name }}
              </p>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-2" v-else>
        <v-col
          class="px-2"
          cols="6"
          sm="4"
          lg="2"
          md="3"
          v-for="(item, index) in list"
          :key="index"
        >
          <div>
            <v-card
              class="rounded-lg pa-3 card-container"
              outlined
              elevation="1"
              width="100%"
              style="border: none; height: 100%"
              @click="openDetail(item)"
              :style="item.total > 1 ? layeredShadow(site.color) : {}"
            >
              <v-chip
                v-if="item.total_expire > 0"
                small
                style="position: absolute; z-index: 10; right: 6px"
                color="red"
                dark
              >
                <span style="font-weight: bold">
                  {{ $t("myLuckyDrawExpire") }} :
                  {{ (item.total_expire - item.total_use || 0) | commaPoint }}
                </span>
              </v-chip>
              <v-chip
                v-else
                small
                style="position: absolute; z-index: 10; right: 6px"
                :color="site.color"
                dark
              >
                <span style="font-weight: bold">
                  {{ $t("luckyDrawCount") }} :
                  {{
                    (item.total - (item.total_use + item.total_expire) || 0)
                      | commaPoint
                  }}
                </span>
              </v-chip>

              <v-img
                :cover="true"
                :aspect-ratio="1"
                width="100%"
                :lazy-src="require('@/assets/images/image.png')"
                :src="item.image_url"
                style="border-radius: 8px 8px 0px 0px"
              >
              </v-img>

              <p
                class="title-mission text-start mb-auto text-subtitle-2 black--text"
                style="height: 44px"
                v-snip="{ lines: 2 }"
              >
                {{ item.name }}
              </p>
              <div
                style="
                  position: absolute;
                  margin-top: 4px;
                  bottom: 12px;
                  width: calc(100% - 24px);
                "
              >
                <div class="justify-end" style="width: 100%">
                  <p
                    v-if="item.total_use"
                    class="text-start mb-1 text-caption black--text"
                    v-snip="{ lines: 1 }"
                  >
                    {{ $t("isUsed") }} :
                    {{ (item.total_use || 0) | commaPoint }}
                  </p>
                  <!-- <v-chip v-if="item.total_expire > 0" small color="red" dark>
                    {{ $t("myLuckyDrawExpire") }}
                  </v-chip> -->
                </div>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <div v-if="!list.length">
        <v-col class="d-flex justify-center mt-16">
          <v-img
            class="white--text mx-auto mt-10 empty"
            :src="require('@/assets/images/out-of-stock.png')"
            max-width="150px"
          >
          </v-img>
        </v-col>
        <p class="text-center">{{ $t("errDataNotFound") }}</p>
      </div>
    </v-container>

    <!--dialog detail reward -->
    <dialogDetailReward
      :dialog="dialog"
      :item="dataDialog"
      :site="site"
      :list="list_data"
      @close="dialog = false"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import moment from "moment";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import dialogDetailReward from "@/components/reward/dialogDetailOnlyType1.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    dialogDetailReward,
  },
  data: () => ({
    page: 1,
    list: [],
    next_page_url: "",
    infiniteId: 0,
    dialog: false,
    dataDialog: {},
    category: "all",
    categoryList: [],
    toggle_view: 1,
    list_data: [],
    title: "",
  }),
  created() {
    this.getCategory();
    this.infiniteHandler();
    const menu = JSON.parse(this.site.menu_account);
    const model = menu?.find((x) => x.to == "my-lucky-draws");
    this.title = model?.name;
  },
  methods: {
    layeredShadow(color) {
      const hex = color.replace("#", "");
      const bigint = parseInt(hex, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;

      return {
        // border: `1px solid rgba(0,0,0,.87)`,
        boxShadow: `0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14), rgba(${r}, ${g}, ${b}, 0.3) 5px -5px, rgba(${r}, ${g}, ${b}, 0.2) 10px -10px !important`,
      };
    },
    getCategory() {
      Axios.get("reward/listRewardCategory").then(({ data }) => {
        if (data.status == "success") {
          let cate = data.data;
          cate.map((item) => {
            this.categoryList.push({
              icon: item.icon,
              label: item.label,
              value: item.category,
            });
          });
          this.categoryList.unshift({
            icon: "order-bool-ascending",
            label: this.$t("categoryAll"),
            value: "all",
          });
        }
      });
    },
    initialize(cate) {
      this.isAppLoading(true);
      this.list = [];
      this.category = cate ? cate.value : "all";
      this.infiniteHandler();
    },
    openDetail(item) {
      console.log("item :>> ", item);
      this.dataDialog = item;
      this.dialog = true;
      this.list_data = item.list;
    },
    infiniteHandler() {
      Axios.get("reward/myLuckyDraw", {
        params: {
          category: this.category,
          perPage: 999999,
          view: this.toggle_view == 1 ? "group" : "individual",
        },
      })
        .then(({ data }) => {
          if (data.data.data.length) {
            this.list = this.list.concat(data.data.data);
            this.list.forEach((element) => {
              element.total_expire = 0;
              element.total_use = 0;

              element.list.forEach((row) => {
                if (this.checkExpiredDate(row.expires_at) == true) {
                  element.total_expire = element.total_expire + 1;
                }
                if (row.status == 2) {
                  element.total_use = element.total_use + 1;
                }
              });
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    checkExpire(value) {
      if (moment().isAfter(value, "day")) {
        return this.$t("expireTime");
      } else {
        return (
          this.$t("expireDateUse") +
          ` ${moment(value.split(" ")[0]).format("D/MM/YYYY")}`
        );
      }
    },
    checkExpiredDate(expireDate) {
      if (!expireDate) return false;
      return moment().startOf("day").isAfter(moment(expireDate).startOf("day"));
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {
    checkExpire(value) {
      if (moment().isAfter(value, "day")) {
        return this.$t("expireTime");
      } else {
        return (
          this.$t("expireDateUse") +
          ` ${moment(value.split(" ")[0]).format("DD MMM YY")}`
        );
      }
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
  watch: {
    toggle_view: {
      handler() {
        this.list = [];
        this.infiniteHandler();
      },
    },
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
  aspect-ratio: 1 / 1.5;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}
.empty {
  opacity: 1;
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  margin: 0px 0px 72px 0px;
  width: 75%;
  text-align: center;
}

.custom-slide-btn {
  background-color: #ffffff !important;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.2s ease-in-out;
}

.custom-slide-btn:hover {
  background-color: #f5f5f5 !important;
  transform: scale(1.08);
}

.custom-slide-btn .v-icon {
  color: #333333 !important;
}
</style>

<style>
.vue-barcode-element {
  width: 100% !important;
}
</style>
